import { fetcher } from "helpers/fetcher";

import { TGetUsersPipelineReq, TGetUsersPipelineRes } from "./types";
import { LanguageType } from "types/index";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getUsersPipeline = async (
  payload?: TGetUsersPipelineReq,
  language?: LanguageType
) => {
  return await fetcher<TGetUsersPipelineRes, any>(
    ENDPOINT.MANAGEMENT.GET_USERS_PIPELINES,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.GET_USERS_PIPELINES.version,
        [API_HEADER.BU_ID]: payload?.buId,
        [API_HEADER.LANGUAGE]: language,
      },
    }
  );
};

export const queryGetUsersPipeline = async (
  payload?: TGetUsersPipelineReq,
  language?: LanguageType
) => {
  return (await getUsersPipeline(payload, language)).data;
};

queryGetUsersPipeline._key = (
  payload?: TGetUsersPipelineReq,
  language?: LanguageType
) => [ENDPOINT.MANAGEMENT.GET_USERS_PIPELINES.url, language, payload];
